import { render, staticRenderFns } from "./rightPreview.vue?vue&type=template&id=0b4f6e0a&scoped=true&"
import script from "./rightPreview.vue?vue&type=script&lang=js&"
export * from "./rightPreview.vue?vue&type=script&lang=js&"
import style0 from "./rightPreview.vue?vue&type=style&index=0&id=0b4f6e0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4f6e0a",
  null
  
)

export default component.exports